import React from 'react';
import { ArrowRight } from 'lucide-react';

const HighlightWord = ({ text }) => (
  <span className="relative inline-block align-baseline whitespace-nowrap">
    <svg
      aria-hidden="true"
      viewBox="0 0 220 80"
      preserveAspectRatio="none"
      className="absolute -left-[4%] -right-[4%] top-[14%] -bottom-[10%] w-[108%] h-[96%] z-0 pointer-events-none"
    >
      <path
        d="M9 32 C 30 22, 70 18, 112 16 C 150 14, 190 18, 213 26 C 218 38, 214 54, 208 64 C 175 72, 130 71, 92 70 C 60 70, 24 68, 7 60 C 2 50, 4 38, 9 32 Z"
        fill="#f8d768"
        opacity="0.72"
      />
    </svg>
    <span className="relative z-10" style={{ color: '#4409cc' }}>{text}</span>
  </span>
);

export default function Hero() {
  return (
    <section className="relative w-full bg-white overflow-hidden">
      {/* Desktop two-column grid: 48% / 52% */}
      <style>{`
        @media (min-width: 1024px) {
          .spiick-hero-grid { grid-template-columns: 48% 52%; }
        }
      `}</style>

      <div className="max-w-[1180px] mx-auto px-6 lg:px-10 pt-10 lg:pt-14 pb-6 lg:pb-12">
        <div className="spiick-hero-grid grid grid-cols-1 gap-10 lg:gap-8 items-center">
          {/* LEFT — text column */}
          <div className="relative z-10 font-display text-center lg:text-left">
            <h1
              className="tracking-tight"
              style={{
                fontFamily: "'Bricolage Grotesque', sans-serif",
                fontSize: 'clamp(3.15rem, 4.5vw, 5.04rem)',
                lineHeight: 0.9,
                fontWeight: 800,
                letterSpacing: '-0.045em',
                color: '#4221B8',
              }}
            >
              Screen-free AI path{' '}
              <HighlightWord text="to English" />
            </h1>

            <p
              className="mt-5 lg:mt-6 text-[16px] lg:text-[17px] leading-relaxed text-[#444251] max-w-[520px] mx-auto lg:mx-0"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 400 }}
            >
              With Spiick, your child speaks, reads, and understands English through interactive activity books and an AI-powered pen that listens, corrects, and encourages — making English acquisition playful, natural, and screen-free.
            </p>

            <div className="mt-6 lg:mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <a
                href="#waitlist"
                data-testid="hero-waitlist-cta"
                className="group inline-flex items-center gap-2 h-14 px-7 rounded-full bg-[#F24540] text-white text-[15px] font-bold hover:bg-[#d93a35] transition-colors"
                style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 700 }}
              >
                Join the waitlist
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
            </div>
          </div>

          {/* RIGHT — illustration column */}
          <div className="relative">
            <div className="relative w-full max-w-[640px] mx-auto lg:mx-0 lg:ml-auto lg:max-w-none lg:-mr-6 xl:-mr-12">
              <img
                src="/spiick_imgs/main-illustration-v4.png"
                alt="Spiick mascot and child with the AI pen"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
